import React from "react";
import { LightArrowRight } from "../../visuals";
import { Body, Heading } from "../../atoms";
import { LabeledCallToAction } from "../LabeledCallToAction";
export default function LabeledCallToActionCard(param) {
    var title = param.title, description = param.description, label = param.label, action = param.action, className = param.className;
    return /*#__PURE__*/ React.createElement("article", {
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex bg-bg-subtle rounded-md p-6 md:p-8"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full grid grid-cols-1 grid-flow-row auto-rows-max gap-5 md:gap-6"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center justify-start"
    }, /*#__PURE__*/ React.createElement(LightArrowRight, {
        className: "mr-4"
    }), /*#__PURE__*/ React.createElement(Heading, {
        as: "h4",
        variant: "h4"
    }, title)), !!description && /*#__PURE__*/ React.createElement(Body, {
        className: "prose"
    }, description), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(LabeledCallToAction, {
        label: label,
        action: action,
        contentClassName: "bg-subtle-700"
    })))));
}

//# sourceMappingURL=LabeledCallToActionCard.js.map